export enum DateFormats {
  'hh:mm:ss aa' = 'hh:mm:ss aa',
  'eee MMM d, yyyy' = 'eee MMM d, yyyy',
  'MM-DD-YYYY' = 'MM-DD-YYYY',
  'mm-dd-yyyy' = 'mm-dd-yyyy',
  'MM-dd-yyyy' = 'MM-dd-yyyy',
  'MM.dd.yyyy' = 'MM.dd.yyyy',
  'dd-MMM yyyy' = 'dd-MMM yyyy',
  'dd-MMM yyyy hh:mm:ss a' = 'dd-MMM yyyy hh:mm:ss a',
  'dd-MMM yyyy HH:mm:ss a' = 'dd-MMM yyyy HH:mm:ss a',
}